import React, {useState} from "react"
import Button from "../../components/Button/Button"
import {updateOrgBankingSetup} from "../../resources/orgBankingSetupType"
import BuildPathDetails from "../../components/BuildPathDetails/BuildPathDetails"
import {buildPathOptions, BuildPathType} from "./buildPathOptions"
import classNames from "classnames"

function BuildPathCard({
	image,
	title,
	subtitle,
	features,
	selected,
	onSelect,
}: {
	image: string
	title: string
	subtitle: string
	features: string[]
	selected: boolean
	onSelect: () => void
}) {
	return (
		<div className="column">
			<div className={classNames("build-option-box", selected && "selected")} onClick={onSelect}>
				<div className="option-image-wrapper">
					<img className="option-image" src={image} alt={title} />
				</div>
				<div className="option-content">
					<h2 className="option-title">{title}</h2>
					<BuildPathDetails subtitle={subtitle} features={features} />
				</div>
			</div>
		</div>
	)
}

interface ChooseBuildPathContentProps {
	accessToken: string
	fetch: () => void
}

export default function ChooseBuildPathContent({accessToken, fetch}: ChooseBuildPathContentProps) {
	const [selectedType, setSelectedType] = useState<BuildPathType | null>(null)
	const [loading, setLoading] = useState<boolean>(false)

	const handleChoice = async (choice: BuildPathType | null) => {
		if (!choice) return
		try {
			setLoading(true)
			await updateOrgBankingSetup(accessToken, choice)
			fetch()
		} catch (e) {
			console.error("Failed to update org banking setup", e)
		} finally {
			setLoading(false)
		}
	}

	return (
		<section className="build-path columns is-centered">
			<div className="column is-8-tablet is-6-desktop">
				<div className="build-path-intro has-text-centered">
					<h1 className="choose-build-path-title">Choose your build path</h1>
					<p className="choose-build-path-subtitle">You can always change your mind later</p>
				</div>

				<div className="build-path-cards-container columns is-variable is-3">
					{(Object.keys(buildPathOptions) as BuildPathType[]).map((type) => {
						const {image, title, subtitle, features} = buildPathOptions[type]
						return (
							<BuildPathCard
								key={type}
								image={image}
								title={title}
								subtitle={subtitle}
								features={features}
								selected={selectedType === type}
								onSelect={() => setSelectedType(type)}
							/>
						)
					})}
				</div>
				<Button
					className="confirm-button is-centered"
					variant="primary"
					theme="neutral"
					onClick={() => handleChoice(selectedType)}
					disabled={!selectedType || loading}
					loading={loading}
				>
					Start Building
				</Button>
			</div>
		</section>
	)
}
